// Plikami — mécanisme anti-perdition n°3 (spec section 4) : retrouver la
// grille (collection ou recherche) à l'endroit exact où on l'a quittée en
// cliquant sur une fiche produit, mais seulement au retour arrière — jamais
// en arrivant par le menu ou le fil d'Ariane.
(() => {
  const STORAGE_PREFIX = 'plikami:scroll:';
  const GRID_SELECTOR = '#product-grid';
  const CARD_SELECTOR = '[data-plk-product-handle]';

  const gridStorageKey = () => STORAGE_PREFIX + location.pathname + location.search;

  const isBackForwardNavigation = () => {
    const [entry] = performance.getEntriesByType('navigation');
    return Boolean(entry) && entry.type === 'back_forward';
  };

  const memorizeOnCardClick = (grid) => {
    grid.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      const card = link ? link.closest(CARD_SELECTOR) : null;
      if (!card || !card.dataset.plkProductHandle) return;

      try {
        sessionStorage.setItem(
          gridStorageKey(),
          JSON.stringify({ handle: card.dataset.plkProductHandle, scrollY: window.scrollY })
        );
      } catch (error) {
        // Stockage indisponible (navigation privée stricte, quota atteint) :
        // le retour se fera simplement sans restauration.
      }
    });
  };

  const readStoredPosition = () => {
    try {
      const raw = sessionStorage.getItem(gridStorageKey());
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  };

  const restoreScrollPosition = () => {
    if (!isBackForwardNavigation()) return;

    const stored = readStoredPosition();
    if (!stored) return;

    // Instantané, jamais animé : restaurer une position est un retour à un
    // état, pas un déplacement — aucun navigateur n'anime sa restauration
    // native. Sur mobile, un défilement animé long met en plus le pouce en
    // concurrence avec l'animation (règle « Le mobile décide »).
    //
    // Deux passages en file d'attente d'animation : le premier laisse le
    // navigateur peindre la grille, le second garantit que cette peinture
    // est bien posée avant qu'on ne défile — sans quoi on obtient parfois
    // un saut visible sur les grilles longues.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const card = stored.handle
          ? document.querySelector(`${GRID_SELECTOR} [data-plk-product-handle="${CSS.escape(stored.handle)}"]`)
          : null;

        if (card) {
          card.scrollIntoView({ block: 'center', behavior: 'auto' });
        } else if (typeof stored.scrollY === 'number') {
          window.scrollTo({ top: stored.scrollY, behavior: 'auto' });
        }
      });
    });
  };

  const grid = document.querySelector(GRID_SELECTOR);
  if (!grid) return;

  // Piloté à la main pour toute la page : sinon la restauration native du
  // navigateur peut s'exécuter en même temps que la nôtre et produire deux
  // défilements superposés au lieu d'un seul, propre.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  memorizeOnCardClick(grid);
  restoreScrollPosition();
})();
